export default __webpack_public_path__ + "static/media/booking-movie-logo.7ebca89e.png";